import { render, staticRenderFns } from "./ProductEditVariantColor.vue?vue&type=template&id=27969bca&scoped=true&"
import script from "./ProductEditVariantColor.vue?vue&type=script&lang=js&"
export * from "./ProductEditVariantColor.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditVariantColor.vue?vue&type=style&index=0&id=27969bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27969bca",
  null
  
)

export default component.exports